import {
  FaReact,
  FaHtml5,
  FaCss3,
  FaNodeJs,
  FaPython,
  FaJava,
  FaGitAlt,
  FaAndroid,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import {
  BiLogoJavascript,
  BiLogoPostgresql,
  BiLogoTypescript,
} from "react-icons/bi";
import {
  SiExpress,
  SiMongodb,
  SiSupabase,
  SiTailwindcss,
  SiMui,
  SiExpo,
  SiFirebase,
  SiKotlin,
  SiSqlite,
  SiSocketdotio,
  SiShadcnui,
} from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";

export const MENU_LINKS = [
  { id: "01", label: "Me", offset: -100, to: "hero" },
  { id: "02", label: "Experience", offset: -80, to: "experience" }, // Good placeholder for Video Editing later
  { id: "03", label: "Projects", offset: -80, to: "projects" }, // Changed "project" to "projects" to match ID
  { id: "04", label: "Certificates", offset: -80, to: "certificates" }, // Changed "project" to "projects" to match ID
];

export const STATS = [
  { id: "01", count: "3+", label: `Years of \nExperience` }, // Adjusted for college student context
  { id: "02", count: "8+", label: `Tech Stack \nMastered` },
  { id: "03", count: "40+", label: `Projects \nCompleted` },
  { id: "04", count: "10+", label: `Freelance \nClients` },
];

export const SKILL_TABS = [
  { id: "01", label: "All", value: "all" },
  { id: "02", label: "Frontend", value: "frontend" },
  { id: "03", label: "Backend", value: "backend" },
  { id: "04", label: "Mobile", value: "mobile" }, // ADDED THIS
  { id: "05", label: "Tools", value: "tools" },
];

export const SKILLS = [
  // --- FRONTEND ---
  {
    id: "f1",
    icon: FaReact,
    skills: "React JS",
    progress: 95,
    type: "frontend",
    description:
      "Building complex interactive UIs with Redux, Context API, and TanStack Query.",
  },
  {
    id: "f2",
    icon: SiTailwindcss,
    skills: "Tailwind CSS",
    progress: 95,
    type: "frontend",
    description:
      "Expert in utility-first styling, dark mode implementation, and responsive design.",
  },
  {
    id: "f3",
    icon: SiShadcnui,
    skills: "ShadCN / MUI",
    progress: 90,
    type: "frontend",
    description:
      "Rapid prototyping using modern component libraries and accessible design patterns.",
  },
  {
    id: "f4",
    icon: BiLogoJavascript,
    skills: "JavaScript (ES6+)",
    progress: 90,
    type: "frontend",
    description:
      "Deep understanding of async/await, DOM manipulation, and functional programming.",
  },

  // --- BACKEND ---
  {
    id: "b1",
    icon: FaNodeJs,
    skills: "Node.js",
    progress: 85,
    type: "backend",
    description:
      "Scalable server-side logic, RESTful API development, and real-time sockets.",
  },
  {
    id: "b2",
    icon: SiSupabase,
    skills: "Supabase",
    progress: 90,
    type: "backend",
    description:
      "Managing Auth, Realtime DB, and Edge functions for rapid backend deployment.",
  },
  {
    id: "b3",
    icon: SiMongodb,
    skills: "MongoDB",
    progress: 85,
    type: "backend",
    description:
      "NoSQL schema design, aggregation pipelines, and Mongoose ORM.",
  },
  {
    id: "b4",
    icon: FaPython,
    skills: "Python",
    progress: 80,
    type: "backend",
    description:
      "Scripting, automation, and desktop app development with Tkinter/PyQt.",
  },

  // --- MOBILE (New Section) ---
  {
    id: "m1",
    icon: TbBrandReactNative,
    skills: "React Native",
    progress: 90,
    type: "mobile",
    description:
      "Cross-platform mobile apps for iOS and Android using Expo and NativeWind.",
  },
  {
    id: "m2",
    icon: SiExpo,
    skills: "Expo",
    progress: 90,
    type: "mobile",
    description:
      "Managing native builds, push notifications, and over-the-air updates.",
  },
  {
    id: "m3",
    icon: FaAndroid,
    skills: "Android (Kotlin)",
    progress: 60,
    type: "mobile",
    description:
      "Native Android development fundamentals using Android Studio.",
  },

  // --- TOOLS ---
  {
    id: "t1",
    icon: FaGitAlt,
    skills: "Git & GitHub",
    progress: 90,
    type: "tools",
    description:
      "Version control workflows, branching strategies, and collaborative coding.",
  },
  {
    id: "t2",
    icon: SiSocketdotio,
    skills: "TanStack / Socket.io",
    progress: 85,
    type: "tools",
    description:
      "Efficient data fetching, caching, and real-time bi-directional communication.",
  },
];

export const ABOUT_ME = {
  content: `I am a Full-Stack Developer and UI/UX enthusiast with a passion for building systems that solve real-world problems. Whether it's a disaster response system like PhaseAlert or a complex academic platform, I focus on performance, scalability, and clean code.

  Beyond coding, I have a creative side as a Video Editor, crafting high-engagement reels and content. This unique blend of technical logic and creative design allows me to build applications that not only work perfectly but look amazing too.`,

  socialLinks: [
    { id: "01", label: "Facebook", icon: FaFacebook, link: "#" },
    { id: "02", label: "Instagram", icon: FaInstagram, link: "#" },
    { id: "03", label: "Twitter", icon: FaXTwitter, link: "#" },
    { id: "04", label: "LinkedIn", icon: FaLinkedin, link: "#" },
  ],

  email: "johnpatrickcezar@CTech.com", // Update with your actual professional email
  phone: "+1 (123) 456-7890",
  website: "https://patrick-portfolio.com",
};
